import ShopTagForm from '@components/shopTag/ShopTagForm'
import React from 'react'
import { useParams } from 'react-router-dom'



export default function EditShopTagPage () {
  const { shopTagId, brandSlug } = useParams<any>()

  return (
    <div className="MakeOrderPage">
      { shopTagId ? (
        <h1 className="u-heading">Редактирование сервиса магазина #{shopTagId}</h1>
      ) : (
        <h1 className="u-heading">Создание магазина</h1>
      )}
      <ShopTagForm shopTagId={shopTagId} brandSlug={brandSlug} />
    </div>

  )
}
